import $ from 'jquery'
import Pageable from 'pageable'

!function(t){"use strict";$.fn.jEmailGenerator=function(a){var e=$.extend({text:"",link:!0,redirect:!1},a);return this.each((function(){var a=t(this);if(void 0!==a.attr("data-ename")&&void 0!==a.attr("data-ehost")&&void 0!==a.attr("data-edomain")){var r=a.attr("data-ename")+"@"+a.attr("data-ehost")+"."+a.attr("data-edomain");""===e.text?a.text(r):!1===e.text||a.text(e.text),!1===e.redirect&&a.is("a")&&a.attr("href","mailto:"+r),!0===e.redirect&&a.on("click",(function(t){t.preventDefault(),window.location.href="mailto:"+r}))}}))}}(jQuery);

$(document).ready(function () {

    if(!$('.containerItems').hasClass('mobile')) {

        const pageable = new Pageable('.pageContainer', {
            pips: false
        })

        $('.scrollPage').click(function() {
            pageable.scrollToPage(parseInt($(this).data('page')))
        })

        $('.goToTop').click(function() {
            pageable.scrollToPage(1)
        })

    } else {

        $('.scrollPage').click(function() {
            const thisPageNumber = $(this).data('page')
            
            $('html, body').animate({
                scrollTop: $(`[data-anchor=page-${ parseInt(thisPageNumber) }]`).offset().top
            }, 1000)
        })

        $('.goToTop').click(function() {
            $('html, body').animate({
                scrollTop: 0
            }, 1000)
        })

    }
})